export default __webpack_public_path__ + "static/media/sy.9c0c367e.svg";